import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';

import Alert from 'components/Alert';

const ToggleRestore = ({
  account,
  updateAccount,
  classes,
}) => {

  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [isRestoring, setIsRestoring] = React.useState(false);
  const [error, setError] = React.useState(null);

  const handleDialogClose = () => {
    setIsRestoring(false);
    setIsDialogOpen(false);
  };

  const handleDialogOpen = () => {
    setIsRestoring(false);
    setIsDialogOpen(true);
  };

  const handleRestoreAccount = async () => {
    setIsRestoring(true);

    try {
      await updateAccount(
        account.id,
        {
          is_deleted: false,
          deleted_at: null,
          deleted_by_user_id: null,
        },
        'Account restored',
      );
    } catch (err) {
      setError(get(err, 'error.message', 'An unknown error occurred.'));
    }

    handleDialogClose();
  };

  return account.is_deleted ? (
    <div className={classes.wrapper}>

      <Button
        onClick={handleDialogOpen}
        disabled={isRestoring}
      >
        {account.is_deleted && isRestoring && 'Restoring...'}
        {account.is_deleted && 'Restore'}
      </Button>

      <Dialog
        open={isDialogOpen}
        fullWidth
        onClose={handleDialogClose}
      >
        <DialogTitle>
          Restore account
        </DialogTitle>

        <DialogContent>
          {error && (
            <Alert
              type="danger"
              message={error}
            />
          )}

          <Typography variant="subtitle1">
            Are you sure you want to restore
            {` ${account.name} `}
            ?
          </Typography>

          <Typography variant="subtitle1">
            All account data will be permanently destroyed on
            {` ${moment(account.deleted_at).add(30, 'days').format('ll')}`}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleDialogClose}
            disabled={isRestoring}
          >
            Cancel
          </Button>

          <Button
            color="primary"
            variant="contained"
            onClick={handleRestoreAccount}
            disabled={isRestoring}
          >
            {isRestoring ? 'Restoring...' : 'Restore'}
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  ) : null;
};

const styles = (theme) => ({
  wrapper: {
    display: 'inline-block',
    marginLeft: theme.spacing(1),
    marginTop: -theme.spacing(0.5),
    verticalAlign: 'middle',
  },
});

ToggleRestore.propTypes = {
  account: PropTypes.object.isRequired,
  updateAccount: PropTypes.func.isRequired,
};

export default withStyles(styles)(ToggleRestore);
